module.exports = __webpack_public_path__ + "static/media/planta.b4827db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/modelo/planta.svg
// module id = 193
// module chunks = 0